$ = require 'jquery'
Board = require 'app/scripts/models/board'
Card = require 'app/scripts/models/card'
{ getKey, Key } = require '@trello/keybindings'
limitExceededTemplate = require 'app/scripts/views/templates/popover_limit_exceeded'
ModelLoader = require 'app/scripts/db/model-loader'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
Payloads = require 'app/scripts/network/payloads'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
Recents = require 'app/scripts/lib/recents'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
ninvoke = require 'app/scripts/lib/util/ninvoke'
selectBoardTemplate = require 'app/scripts/views/templates/select_board'
selectCardTemplate = require 'app/scripts/views/templates/select_card'
SidebarState = require 'app/scripts/view-models/sidebar-state'
template = require 'app/scripts/views/templates/popover_trello_completer'
{ track } = require '@trello/analytics'
ApiError = require 'app/scripts/network/api-error'

module.exports = class TrelloCompleterView extends View
  viewTitleKey: 'add card or board'

  events:
    'mouseenter .js-select-card,.js-select-board': 'hoverItem'
    'click .js-select-card': 'selectCard'
    'click .js-select-board': 'selectBoard'
    'keydown': 'keydownEvent'
    'keyup .js-search': 'keyupEvent'
    'input .js-search': 'updateSearch'

  initialize: ->
    @items = []
    @debouncedSearch = @debounce(@search, 350).bind(@)
    @search("")

  render: ->
    view = @
    data = {}

    if !@model.canAttach()
      if @model.isOverLimit('attachments', 'perCard')
        @$el.html(limitExceededTemplate('perCard'))
      else if @model.getBoard().isOverLimit('attachments', 'perBoard')
        @$el.html(limitExceededTemplate('perBoard'))
      return @

    @$el.html(template(data))

    Promise.resolve(@_lastRenderPromise)
    .then =>
      @renderItems()
    .done()

    @

  renderItems: ->
    @$('.js-loading').addClass('hide')

    hiddenCards = new Set([@model.get('shortLink')])
    hiddenBoards = new Set()

    @model.attachmentList.forEach (attachment) ->
      url = attachment.get('url')
      { type, shortLink } = parseTrelloUrl(url)
      switch type
        when 'card' then hiddenCards.add(shortLink)
        when 'board' then hiddenBoards.add(shortLink)

    cards = @items.filter (item) ->
      item instanceof Card && !hiddenCards.has(item.get('shortLink'))
    boards = @items.filter (item) ->
      item instanceof Board && !hiddenBoards.has(item.get('shortLink'))

    $cardList = @$('.js-card-list').empty()
    $boardList = @$('.js-board-list').empty()

    if cards.length > 0
      cardHtml = for card in cards
        data = card.toJSON()
        board = card.getBoard()

        if board?
          data.boardName = board.get('name')

        selectCardTemplate(data)

      $cardList.append cardHtml

    if boards.length > 0
      boardHtml = for board in boards
        data = board.toJSON()

        if (org = board.getOrganization())?
          data.orgName = org.get('displayName')

        selectBoardTemplate(data)

      $boardList.append boardHtml

    if @items.length > 0
      Util.selectMenuItem(@$el, '.item', @$el.find('.item').first())

    hideCardResults = !@_lastQuery && cards.length == 0
    hideBoardResults = !@_lastQuery && boards.length == 0
    @$('.js-card-results').toggleClass('hide', hideCardResults)
    @$('.js-board-results').toggleClass('hide', hideBoardResults)
    @$('.js-no-card-results').toggleClass('hide', cards.length > 0)
    @$('.js-no-board-results').toggleClass('hide', boards.length > 0)

    @

  keyupEvent: (e) ->
    key = getKey(e)

    if key in [Key.ArrowUp, Key.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$el, '.item', key)
    return

  updateSearch: (e) ->
    query = @$('.js-search').val()
    @debouncedSearch(query)

  keydownEvent: (e) ->
    if getKey(e) in [Key.Enter, Key.Tab]
      Util.stop(e)
      $item = @$el.find('.item.selected:first').find('.js-select-card,.js-select-board')
      if $item.length > 0
        $item.click()

  getTextInput: ->
    $(@options.target)

  _renderSettledItems: (query, eventualItems) ->
    if query != @_lastQuery
      return

    @_lastRenderPromise = Promise.resolve(eventualItems)
    .then (items) ->
      if _.isArray(items)
        items
      else
        [items]
    .catch ApiError, ->
      []
    .tap (items) =>
      @items = items
      @renderItems()
    .finally =>
      @_lastRenderPromise = null

  search: (query) ->
    if query == @_lastQuery
      return

    @_lastQuery = query

    @$('.js-card-results').addClass('hide')
    @$('.js-board-results').addClass('hide')
    @$('.js-loading').removeClass('hide')

    if query == ""
      RECENT_COUNT = 5

      idRecentCards =
        _.chain(Recents.get('card', RECENT_COUNT + 1))
        .without(@model.id)
        .first(RECENT_COUNT)
        .value()

      idRecentBoards = _.chain(SidebarState.getRecentBoards())
        .without(@model.get('idBoard'))
        .first(RECENT_COUNT)
        .value()

      recentItems =
        Promise.props
          recentCards: Promise.map idRecentCards, (idCard) =>
            @modelCache.getOrLoad
              type: 'Card',
              id: idCard,
              payload: Payloads.cardCompleter
              loader: (id) -> ModelLoader.loadCardCompleterData(id)

          recentBoards: Promise.map idRecentBoards, (idBoard) =>
            @modelCache.getOrLoad
              type: 'Board'
              id: idBoard
              payload: Payloads.boardCompleter
              loader: (id) -> ModelLoader.loadBoardCompleterData(id)

        .then ({ recentCards, recentBoards }) ->
          _.compact([recentCards..., recentBoards...])

      @_renderSettledItems(query, recentItems)
      return

    # See if they're just putting in a URL
    parsedTrello = parseTrelloUrl(query.trim())
    if parsedTrello.type == 'card'
      @_renderSettledItems(query, ModelLoader.loadCardCompleterData(parsedTrello.shortLink))
      return
    else if parsedTrello.type == 'board'
      @_renderSettledItems(query, ModelLoader.loadBoardCompleterData(parsedTrello.shortLink))
      return

    # Search for a card short id
    if Util.isShortId(query)
      card = @options.card
      board = card?.getBoard()
      if board?
        if (referencedCard = board.getCard(query))?
          @_renderSettledItems(query, referencedCard)
        else
          @_renderSettledItems(query, ModelLoader.loadCardData(board.id, query))
        return

    # Search for a phrase
    searchOptions = {
      query
      board_fields: 'name,idOrganization,url'
      modelTypes: 'cards,boards'
      partial: true
      card_board: true
    }

    ModelLoader.loadSearchData(searchOptions).nodeify (err, results) =>
      if !err?
        cards = _.chain(results.cards)
          .map (card) =>
            @modelCache.get('Card', card.id)
          .sortBy (card) =>
            if card.get('idBoard') == @model.get('idBoard')
              0
            else
              1
          .value()

        boards = _.chain(results.boards)
          .map (board) =>
            @modelCache.get('Board', board.id)
          .sortBy (board) =>
            # Why would you attach a card's board to itself?
            if board.get('id') == @model.get('idBoard')
              1
            else
              0
          .value()

        @_renderSettledItems query, [cards..., boards...]
      else
        @items = []
        @renderItems()
    return

  hoverItem: (e) ->
    $elem = $(e.target).closest('.item')
    Util.selectMenuItem(@$el, '.item', $elem)

  selectCard: (e) ->
    Util.stop(e)
    idCard = @$(e.target).closest('.js-select-card').attr('data-id')
    card = @modelCache.get('Card', idCard)
    if card?
      @insertItem(card)
    return

  selectBoard: (e) ->
    Util.stop(e)
    idBoard = @$(e.target).closest('.js-select-board').attr('data-id')
    board = @modelCache.get('Board', idBoard)
    if board?
      @insertItem(board)
    return

  insertItem: (item) ->
    if @options.onStartUpload
      @options.onStartUpload(item)
      return

    url = item.get('url')
    $textInput = @getTextInput()
    caretPosition = Util.getCaretPosition($textInput)
    if caretPosition?
      word =
        start: caretPosition
        end: caretPosition

    Util.insertSelection($textInput, "#{ url } ", word?.start, word?.end)
    track("Card Detail",
      if item instanceof Card then "Comment Box - Added Card" else "Comment Box - Added Board",
      "via menu"
    )
